import Vue from 'vue'
import UUID from 'vue-uuid'
import '../public/theme/index.css'
import ElementUI from 'element-ui';
import lang from 'element-ui/lib/locale/lang/tr-TR'
import locale from 'element-ui/lib/locale'
import LiquorTree from 'liquor-tree'
import axios from 'axios'
import App from './App.vue'
import store from './store'
import router from './router'
import { Message } from 'element-ui'
import ElInputTag from 'el-input-tag'
import dotenv from 'dotenv'
import Clipboard from 'v-clipboard'
import underscore from 'vue-underscore';
dotenv.config();
locale.use(lang)
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
axios.interceptors.response.use(response => response, error => {
  if (error.response.status === 401 && window.location.pathname != '/login') {
    router.push('/login')
  }
  else if (error.response.status === 400) {
    (error.response.data.errors.forEach(x => setTimeout(() => Message.error(`${x.param}: ${x.msg}`), 1)))
    throw error
  }
  else if (error.response.status === 409 || error.response.status === 404) {
    Message.error(error.response.data.message)
    throw error
  }
  else if (error.response.status.toString().startsWith('4')) {
    Message.error(error.response.data.message)
    throw error
  }
  throw error
})
let user = JSON.parse(localStorage.getItem('adminUser'));

if (user && user.token) {
  axios.defaults.headers.common['token'] = user.token
}
Vue.use(Clipboard)
Vue.use(underscore);
Vue.use(ElementUI)
Vue.use(ElInputTag)
Vue.use(LiquorTree)
Vue.config.productionTip = false
Vue.use(UUID)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
